import "@/scripts/global/utils/custom-delegate";
import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse';
import psnNavigation from "@/scripts/sections/psn-navigation";
import productCard from "@/scripts/product/product-card";
import swiper from "@/scripts/swiper";
import { formatMoney, getPricePerUnit, getVariantUnitTotalQuantity } from "@/scripts/global/utils/helpers";
import cart from "@/scripts/templates/cart/psn-cart";
import psnCollection from "@/scripts/templates/collection/psn-collection";
import PsnProductBundle from "@/scripts/product/psn-product-bundle";
import cardGallery from "@/scripts/product/psn-card-gallery";
import productGallery from "@/scripts/templates/product/psn-product_gallery"
import product from "@/scripts/templates/product/psn-product"
import starterKitSubscriptionWidget from "@/scripts/templates/product/psn-starter-kit-subscription-widget"
import imageBanner from "@/scripts/sections/image-banner";
import blog from "@/scripts/sections/blog";
import footerSlider from "@/scripts/sections/footer-slider"
import account from "@/scripts/sections/account";
import splideSlider from "@/scripts/components/splide-slider";
import mobileBestsellersCarousel from "@/scripts/components/psn-mobile-bestsellers-carousel";
import accordion from "@/scripts/components/psn-accordion";
import backInStockCountDown from "@/scripts/product/product-back-in-stock-countdown";
import ingredients from "@/scripts/sections/psn-ingredients";
import psnFeaturedIn from "@/scripts/sections/psn-featured-in";
import psnSubscriptionTable from "@/scripts/sections/psn-subscription-table";
window.Alpine = Alpine
window.formatMoney = formatMoney
window.getPricePerUnit = getPricePerUnit
window.getVariantUnitTotalQuantity = getVariantUnitTotalQuantity

Alpine.plugin(collapse)

document.addEventListener("alpine:init", () => {
    Alpine.data("swiper", swiper)
    Alpine.data("navigation", psnNavigation)
    Alpine.data("product_card", productCard)
    Alpine.store("cart", cart())
    Alpine.data("productGallery", productGallery)
    Alpine.data("product", product)
    Alpine.data("starterKitSubscriptionWidget", starterKitSubscriptionWidget)
    Alpine.data("collection", psnCollection)
    Alpine.data("card_gallery", cardGallery)
    Alpine.data("imageBanner", imageBanner);
    Alpine.data("blog", blog);
    Alpine.data("footer_slider", footerSlider);
    Alpine.data("account", account);
    Alpine.data("splide", splideSlider);
    Alpine.data("mobileBestsellersCarousel", mobileBestsellersCarousel);
    Alpine.data("ingredients", ingredients);
    Alpine.data("backInStockCountDown", backInStockCountDown);
    Alpine.data("psnFeaturedIn", psnFeaturedIn);
    Alpine.data("accordion", accordion)
});

document.addEventListener('DOMContentLoaded', () => {
    new PsnProductBundle();
});

Alpine.start()

let SuperTheme = {

}

window.SuperTheme = SuperTheme

window.addEventListener('load', () => {

    // Toggle Plan Picker Visibility
    const options = document.querySelectorAll('[data-plan-picker]')
    options.forEach(option => {
        option.style.display = easylocation.locationData.country.iso_code == 'GB' ? 'block' : 'none'
    })

});
